<div class="tw-rounded-xl tw-bg-dt-surface-card tw-overflow-hidden">
  <div
    class="tw-flex tw-items-start tw-p-7 tw-space-x-4 sm:tw-flex-col sm:tw-space-x-0 sm:tw-space-y-3"
  >
    <span class="transaction-form-label tw-text-orange-800 dark:tw-text-dt-text-past-primary"
      >Reval.</span
    >
    <div class="tw-flex tw-flex-col tw-space-y-1 tw-ml-2 sm:tw-ml-0">
      <span class="tw-text-2xl sm:tw-text-xl tw-text-dt-text-headings tw-font-medium">
        {{ isSymbol ? ("exchangeRateReval" | i18n) : ("assetRevalAdjustment" | i18n) }}
      </span>
      <span
        class="tw-text-lg sm:tw-text-base tw-text-dt-text-secondary tw-leading-5 sm:tw-leading-4"
      >
        {{ isSymbol ? ("exchangeRateRevalMsg" | i18n) : ("assetRevalAdjustmentMsg" | i18n) }}
      </span>
    </div>
  </div>

  <hr class="border-dashed" />

  <div
    class="tw-grid tw-grid-cols-[minmax(80px,auto)_1fr] sm:tw-grid-cols-[minmax(50px,100px)_1fr] tw-items-center tw-gap-x-10 tw-gap-y-3 sm:tw-gap-x-1 tw-px-6 tw-py-5 sm:tw-px-4 sm:tw-py-4"
  >
    <label class="transaction-form-heading">
      {{ "balanceAsOf" | i18n }}
      [{{ data?.date | date: "yyyy-MM-dd" }}]
    </label>

    <label class="transaction-form-subheading">{{ "holding" | i18n }}</label>
    <div class="transaction-form-content">
      <span>{{ data?.transactionSymbol }}</span>
      <span [attr.data-testid]="'holding-amount'">{{ data?.balance | number: "1.2-2" }}</span>
    </div>

    <div class="tw-col-span-2 tw-flex tw-space-x-3 tw-mt-3">
      <div class="tw-flex-grow tw-basis-0">
        <label class="transaction-form-subheading">
          {{ isSymbol ? ("heldSymbol" | i18n) : ("symbol" | i18n) }}
          <span *ngIf="isSymbol" class="tw-text-dt-text-secondary tw-font-normal tw-inline"
            >({{ "currency" | i18n }})</span
          >
        </label>
        <span class="transaction-form-content tw-items-center tw-justify-center">{{
          data?.transactionSymbol
        }}</span>
      </div>

      <div class="tw-flex tw-items-end">
        <icon
          [name]="'arrow-right'"
          [size]="5"
          class="tw-p-2.5 tw-border tw-border-dt-border-tertiary tw-rounded-full tw-bg-dt-surface-elevated"
        ></icon>
      </div>

      <div class="tw-flex-grow tw-basis-0 sm:tw-self-end">
        <label class="transaction-form-subheading">{{ "coreCurrency" | i18n }}</label>
        <span class="transaction-form-content tw-items-center tw-justify-center">{{
          coreCurrency
        }}</span>
      </div>
    </div>

    <label class="transaction-form-subheading tw-col-span-2 tw-mt-3">
      {{ isSymbol ? ("exchangeRate" | i18n) : ("closingPrice" | i18n) }}
    </label>
    <div *ngFor="let history of exchangeRate" class="tw-flex tw-justify-between tw-col-span-2">
      <label>{{ history?.date.date | date: "yyyy-MM-dd" }}</label>
      <div>
        <span>1 {{ history?.base }} =&nbsp;</span>
        <span>{{ history?.rate | number: "1.4-4" }} {{ history?.symbol }}</span>
      </div>
    </div>

    <label class="transaction-form-heading tw-mt-10">{{ "resultedIn" | i18n }}</label>
    <label class="transaction-form-subheading sm:tw-mr-1">
      {{ isSymbol ? ("rateChangeEffect" | i18n) : ("priceChangeImpact" | i18n) }}
    </label>
    <div class="transaction-form-content">
      <span>{{ data?.symbol }}</span>
      <span
        [ngClass]="exchRateDiff > 0 ? 'tw-text-dt-text-in-primary' : 'tw-text-dt-text-out-primary'"
        class="tw-font-medium"
        >{{ exchRateDiff | number: "1.2-4" }}</span
      >
    </div>
  </div>
</div>
